import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "cmd00110-input-form q-gutter-y-xs" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  key: 1,
  class: "q-ml-sm q-mt-sm"
}
const _hoisted_7 = { class: "col flex justify-end" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "row q-gutter-x-md" }
const _hoisted_11 = { class: "col-3" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = {
  key: 0,
  class: "row q-mt-md"
}
const _hoisted_15 = { class: "col column" }
const _hoisted_16 = { class: "q-mb-none q-ml-sm q-mt-sm" }
const _hoisted_17 = { class: "col column" }
const _hoisted_18 = { class: "q-mb-none q-ml-sm q-mt-sm" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col q-gutter-x-xs flex justify-end" }

import Loading from 'quasar/src/plugins/Loading.js';;
import { reactive, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import DisplayModeCode from '../../common/code/DisplayModeCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import { isEmpty, isHalfAlphanumeric } from '../../common/utils/validateUtils';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';

interface Props {
  // 登録・変更モード
  mode: string;
  // サプライヤコード
  supplierCd?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00110',
  props: {
    mode: {},
    supplierCd: {}
  },
  setup(__props: any) {

const router = useRouter();
const props = __props;

// サプライヤコードフォーカス用
const supplierCodeElem = ref<HTMLImageElement>();
// サプライヤ名フォーカス用
const supplierNameElem = ref<HTMLImageElement>();
// AlertDialog表示フラグ
const isDialogFlg = ref(false);
// AlertDialog表示フラグ
const isAlertFlg = ref(false);
// MessageChip表示フラグ
const isMessageChip = ref(false);
// エラーメッセージ
const errMessage = ref('');
// サプライヤコード
const supplierCode = ref(props.supplierCd ? props.supplierCd : '');

// 初期化用データ
const resetData = reactive({
  supplier_code: '',
  supplier_name: '',
  priority: '1',
  real_supplier_code: '',
  real_supplier_name: '',
  maker_code: '',
  del_flg: false,
  create_timestamp: '',
  create_user_name: '',
  update_user_name: '',
});

// 入力データ
const inputData = ref({ ...resetData });

/**
 * エラー初期化
 */
const resetErrors = () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * サプライヤ登録
 */
const registerSupplier = async () => {
  resetErrors();
  // Loading Start
  Loading.show();
  // 登録データ
  const formData = new FormData();
  formData.append('supplier_code', inputData.value.supplier_code);
  formData.append('supplier_name', inputData.value.supplier_name);
  formData.append('priority', inputData.value.priority);
  formData.append('real_supplier_code', inputData.value.real_supplier_code);
  formData.append('real_supplier_name', inputData.value.real_supplier_name);
  formData.append('maker_code', inputData.value.maker_code);

  // サプライヤ登録
  await axios
    .post('/cmd001101/register', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isAlertFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.DUPLICATE_SUPPLIER_ERROR:
            case DetailResultStatusCode.INSERT_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * サプライヤ更新
 */
const updateSupplier = async () => {
  resetErrors();
  // Loading Start
  Loading.show();
  // 更新データ
  const formData = new FormData();
  formData.append('supplier_code', inputData.value.supplier_code);
  formData.append('supplier_name', inputData.value.supplier_name);
  formData.append('priority', inputData.value.priority);
  formData.append('real_supplier_code', inputData.value.real_supplier_code);
  formData.append('real_supplier_name', inputData.value.real_supplier_name);
  formData.append('maker_code', inputData.value.maker_code);
  formData.append('del_flg', inputData.value.del_flg ? '1' : '0');

  // サプライヤ更新
  await axios
    .post('/cmd001102/change', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isAlertFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.DUPLICATE_SUPPLIER_ERROR:
            case DetailResultStatusCode.UPDATE_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * サプライヤ取得
 */
const getSupplier = async () => {
  // Loading Start
  Loading.show();
  // 検索用データ作成
  const formData = new FormData();
  formData.append('supplier_code', supplierCode.value);

  // サプライヤ取得
  await axios
    .post('/cmd001102/search', formData)
    .then((res) => {
      const { common, supplier } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 初期化用データ
          Object.assign(resetData, supplier);
          resetData.del_flg = supplier.del_flg !== '0';
          resetData.maker_code = supplier.maker_code ? supplier.maker_code : '';
          // フォームデータ
          inputData.value = { ...resetData };
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * フォーム初期化
 */
const resetForm = () => {
  inputData.value = { ...resetData };
  resetErrors();
  // 変更の場合
  if (props.mode === DisplayModeCode.CHANGE) {
    // サプライヤ名にフォーカス
    supplierNameElem.value?.focus();
  } else {
    supplierCodeElem.value?.focus();
  }
};

/**
 * submit
 */
const submit = () => {
  resetErrors();
  isDialogFlg.value = false;
  if (props.mode === DisplayModeCode.REGISTER) {
    registerSupplier();
  } else {
    updateSupplier();
  }
};

/**
 * 初期表示処理
 */
onMounted(() => {
  // propsが存在しない場合
  if (!props.mode) {
    // 前画面に遷移
    router.replace({ name: 'supplier' });
  }
  // 変更の場合
  if (props.mode === DisplayModeCode.CHANGE) {
    // サプライヤ名にフォーカス
    supplierNameElem.value?.focus();
    getSupplier();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => [
        (props.mode === _unref(DisplayModeCode).REGISTER)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "サプライヤ新規登録"))
          : _createCommentVNode("", true),
        (props.mode === _unref(DisplayModeCode).CHANGE)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "サプライヤ情報変更"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createVNode(_component_q_form, {
      autofocus: "",
      "no-reset-focus": "",
      greedy: "",
      onSubmit: _cache[16] || (_cache[16] = ($event: any) => (isDialogFlg.value = true)),
      onReset: resetForm,
      onValidationError: resetErrors
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", {
                class: _normalizeClass(props.mode === _unref(DisplayModeCode).REGISTER ? 'requier' : '')
              }, " サプライヤコード ", 2),
              (props.mode === _unref(DisplayModeCode).REGISTER)
                ? (_openBlock(), _createBlock(_component_q_input, {
                    key: 0,
                    ref_key: "supplierCodeElem",
                    ref: supplierCodeElem,
                    modelValue: inputData.value.supplier_code,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputData.value.supplier_code) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)","width":"50%"},
                    class: "input-area",
                    maxlength: "4",
                    rules: [
                (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                (val) => _unref(isHalfAlphanumeric)(val) || _ctx.$t('validation.half_alphanumeric_only'),
              ],
                    "lazy-rules": "",
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue", "rules"]))
                : _createCommentVNode("", true),
              (props.mode === _unref(DisplayModeCode).CHANGE)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(inputData.value.supplier_code), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (props.mode === _unref(DisplayModeCode).CHANGE)
                ? (_openBlock(), _createBlock(_component_q_toggle, {
                    key: 0,
                    modelValue: inputData.value.del_flg,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputData.value.del_flg) = $event)),
                    label: "無効にする",
                    "left-label": "",
                    size: "lg"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "requier" }, "サプライヤ名", -1)),
            _createVNode(_component_q_input, {
              ref_key: "supplierNameElem",
              ref: supplierNameElem,
              modelValue: inputData.value.supplier_name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputData.value.supplier_name) = $event)),
              outlined: "",
              dense: "",
              style: {"background":"var(--q-white)"},
              class: "input-area left-input",
              maxlength: "200",
              rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
              "lazy-rules": "",
              onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "requier" }, "優先順位", -1)),
            _createVNode(_component_q_input, {
              modelValue: inputData.value.priority,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputData.value.priority) = $event)),
              outlined: "",
              dense: "",
              style: {"background":"var(--q-white)","width":"25%"},
              class: "input-area",
              maxlength: "4",
              mask: "####",
              rules: [
              (val) => !!val || _ctx.$t('validation.required'),
              (val) =>
                (val > 0 && val <= 9999) ||
                _ctx.$t('validation.between', { param1: '1', param2: '9999' }),
            ],
              "lazy-rules": "",
              onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
              onKeypress: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[22] || (_cache[22] = _createElementVNode("label", null, "仕入先コード", -1)),
              _createVNode(_component_q_input, {
                modelValue: inputData.value.real_supplier_code,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((inputData.value.real_supplier_code) = $event)),
                outlined: "",
                dense: "",
                style: {"background":"var(--q-white)"},
                class: "input-area",
                maxlength: "7",
                rules: [(val) => _unref(isHalfAlphanumeric)(val) || _ctx.$t('validation.half_alphanumeric_only')],
                "lazy-rules": "",
                onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[23] || (_cache[23] = _createElementVNode("label", null, "仕入先名", -1)),
              _createVNode(_component_q_input, {
                modelValue: inputData.value.real_supplier_name,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((inputData.value.real_supplier_name) = $event)),
                outlined: "",
                dense: "",
                style: {"background":"var(--q-white)"},
                class: "input-area",
                maxlength: "200",
                "lazy-rules": "",
                hint: "",
                onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[24] || (_cache[24] = _createElementVNode("label", null, "メーカーコード", -1)),
            _createVNode(_component_q_input, {
              modelValue: inputData.value.maker_code,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((inputData.value.maker_code) = $event)),
              outlined: "",
              dense: "",
              style: {"background":"var(--q-white)","width":"25%"},
              class: "input-area",
              maxlength: "9",
              mask: "#########",
              "lazy-rules": "",
              onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
              onKeypress: _cache[14] || (_cache[14] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue"])
          ]),
          (props.mode === _unref(DisplayModeCode).CHANGE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", null, "登録者", -1)),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(inputData.value.create_user_name), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", null, "登録日時", -1)),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(inputData.value.create_timestamp), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
            "button-area": _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_q_btn, {
                  color: "grey-7",
                  outline: "",
                  label: "戻る",
                  style: {"min-width":"120px","background":"var(--q-white) !important"},
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(router).replace({ name: 'supplier' })))
                }),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_q_btn, {
                    type: "submit",
                    color: "primary",
                    style: {"width":"150px"},
                    label: props.mode === _unref(DisplayModeCode).REGISTER ? '登録' : '変更'
                  }, null, 8, ["label"]),
                  _createVNode(_component_q_btn, {
                    type: "reset",
                    outline: "",
                    style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                    icon: props.mode === _unref(DisplayModeCode).REGISTER ? 'mdi-eraser' : 'cached',
                    label: props.mode === _unref(DisplayModeCode).REGISTER ? 'クリア' : 'リセット'
                  }, null, 8, ["icon", "label"])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: isDialogFlg.value,
      level: "information",
      title: props.mode === _unref(DisplayModeCode).REGISTER ? '登録確認' : '更新確認',
      text: 
        props.mode === _unref(DisplayModeCode).REGISTER
          ? ['入力された内容で登録します。', 'よろしいですか？']
          : ['入力された内容で更新します。', 'よろしいですか？']
      ,
      onConfirm: _cache[17] || (_cache[17] = ($event: any) => (submit())),
      onClose: _cache[18] || (_cache[18] = ($event: any) => (isDialogFlg.value = false))
    }, null, 8, ["display", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isAlertFlg.value,
      level: "information",
      confirmation: "",
      title: props.mode === _unref(DisplayModeCode).REGISTER ? '登録完了' : '更新完了',
      text: 
        props.mode === _unref(DisplayModeCode).REGISTER
          ? ['登録が完了しました。']
          : ['更新が完了しました。']
      ,
      onComplete: _cache[19] || (_cache[19] = ($event: any) => (_unref(router).replace({ name: 'supplier' })))
    }, null, 8, ["display", "title", "text"])
  ]))
}
}

})